export const dataConfig = {
  forgotPasswordEP: '/password-reset-token/send',
};
